import * as React from "react";
import { User } from "../../../mobxStores/user/user";
import { observer } from "mobx-react-lite";
import { ProviderLogin } from "../providerLogin";
import { Registration } from "./registration";
import { Login } from "./login";

// UI Work
// Registration - isCustomer=false
//   Show selecting a billing account if it has billing accounts where it is the admin
//   Fetch billing accounts, get roles for each, filter by billing_admin, ask to select and convert to aws (requires endpoint)
//   Create billing account with provider aws and org/gvc
//   Updated old billing creation forms to send provider as controlplane
// Login - isCustomer=true
//   Fetch billing accounts, find the one with given id
//   If not, inform that belongs to someone else, already created
//   List the orgs of the account, select the first one
//   If there are no orgs, go to billing screen
// Checking info -- Left to do
//   Switching from aws to controlplane
//      automatic after unsubscribe-success, uses the current payment methods, if not, the orgs are disabled
//      show guidance in the UI
//   Show if provider is aws or controlplane in the billing detail page
//   Show if billing account is subcribed/unsubscribe pending/unsubscribed/subscribe failed
//   Update setup pages logic for an account depending on the aws provider type

// has account no org
// http://localhost:4026/provider/aws?awsAccountId=604102635701&accountId=8ab95405-ea46-4f2c-925b-96fdb3d31f84

// has account has org - has NOT access
// http://localhost:4026/provider/aws?awsAccountId=604102635701&accountId=8ab95405-ea46-4f2c-925b-96fdb3d31f84

// has account has org - has access
// http://localhost:4026/provider/aws?awsAccountId=604102635701&accountId=302f6926-ea12-45fa-9898-23d88f3e1628

// no account
// http://localhost:4026/provider/aws?awsAccountId=378988487521&providerId=378988487521

const NOT_SET = "notset";

const MarketplaceProviderAWSRaw: React.FC = () => {
  function getCustomerIdentifier() {
    const key = `customerIdentifier=`;
    try {
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || NOT_SET;
    } catch (e) {
      return NOT_SET;
    }
  }
  const [customerIdentifier] = React.useState(getCustomerIdentifier());
  function getAwsAccountId() {
    const key = `awsAccountId=`;
    try {
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || NOT_SET;
    } catch (e) {
      return NOT_SET;
    }
  }
  const [awsAccountId] = React.useState(getAwsAccountId());
  function getProviderId() {
    try {
      const key = `providerId=`;
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || NOT_SET;
    } catch (e) {
      return NOT_SET;
    }
  }
  const [providerId] = React.useState(getProviderId());
  function getBillingAccountId() {
    try {
      const key = `accountId=`;
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || "";
    } catch (e) {
      return "";
    }
  }
  const [accountId] = React.useState(getBillingAccountId());
  const [isCustomer] = React.useState(!!getBillingAccountId());

  return (
    <>
      <div
        className="marketplace-provider marketplace-provider-aws enable-overflow w-full flex justify-center pt-16"
        style={{ minHeight: `100vh` }}
      >
        <div>
          <div>
            {User.isLoggedIn ? (
              isCustomer ? (
                <Login awsAccountId={awsAccountId!} providerId={providerId!} billingAccountId={accountId!} />
              ) : (
                <Registration
                  awsAccountId={awsAccountId!}
                  providerId={providerId!}
                  customerIdentifier={customerIdentifier!}
                />
              )
            ) : (
              <ProviderLogin isCustomer={isCustomer} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export const MarketplaceProviderAWS = observer(MarketplaceProviderAWSRaw);
